<template>
  <div v-bem>
    <iframe
      v-if="version['360_exist'] == 1"
      title="interior"
      :src="`/onlinestore/three-sixty/interior/?image=${interior}`"
      frameBorder="0"
    ></iframe>
    <p class="notice">{{$t('notices.images')}}</p>
    <div class="cta">
      <button class="button button--primary" @click="$emit('next-step')"><span class="button__text">{{$t('cta.continue')}}</span></button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'InsideView',
  computed: {
    model() {
      return this.$store.state.models.find(model => model.id_simulateur_modele === this.$store.state.selected.model);
    },
    version() {
      return this.model.voitures.find(version => version.id_simulateur === this.$store.state.selected.version.id);
    },
    interior() {
      return `https://www.succursalesrenault.ma/onlinestore/360/${this.model.nom_lien.toLowerCase()}/${this.version.nom_version}/360.jpg`;
    },
  },
  // created() {
  //   axios.post(`https://succursalesrenault.ma/onlinestore/admin/public/api/updateinsc/${localStorage.getItem('clientId')}`, {
  //     model  : this.$store.state.selected.model,
  //     version: this.$store.state.selected.version.id,
  //     couleur: this.$store.state.selected.color
  //   })
  //     .then(({status}) => status === 200)
  //     .catch(err => console.error(err))
  // }
}
</script>

<style scoped lang="scss">
.inside-view {
  text-align: center;
  max-width: rem(1000);
  margin: 0 auto rem(30);
  padding-bottom: rem(30);
  padding: 0 rem(10);
  iframe {
    width: 100%;
    height: rem(500);
    border: rem(1) solid $gray;
  }
  .notice {
    color: $dark-gray;
    @include font-size;
    max-width: rem(1000);
    margin: 0 auto rem(30);
    text-align: center;
  }
  @include breakpoint('charmander') {
    margin: rem(20) rem(10);
    iframe {
      height: rem(360);
    }
  }
}
</style>